module.exports = __webpack_public_path__ + "img/order.e2e170e1.png";